import api from '@/api'
import {
  SET_SUBJECT_LIST,
  SET_COMPANY_LIST,
  SET_MANAGER,
} from './mutation-types'

const state = {
  subjectList: [],   // 预算科目列表
  companyList: [],   // 公司名列表
  manager: '',
}

const mutations = {
  [SET_SUBJECT_LIST] (state, payload) {
    state.subjectList = payload
  },
  [SET_COMPANY_LIST] (state, payload) {
    state.companyList = payload
  },
  [SET_MANAGER] (state, payload) {
    state.manager = payload
  },
}

const actions = {
  async getBudgetInfos ({state, commit}) {
    if (state.subjectList.length !== 0) return false
    const {data} = await api.financeApi.getBudgetInfos()
    commit(SET_SUBJECT_LIST, data)
    return data
  },
  async getCompanyAndOrgs ({state, commit}) {
    if (state.subjectList.length === 0) return false
    const {data} = await api.financeApi.getCompanyAndOrgs()
    commit(SET_COMPANY_LIST, data)
    return data
  },
  async getManagerByOrg ({state, commit}, payload) {
    const {data} = await api.financeApi.getManagerByOrg({name: payload})
    commit(SET_MANAGER, data)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
